var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.59 26.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1dfba;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.41,0A.4.4,0,0,0,0,.45L2.08,23.71a.68.68,0,0,0,.47.56l8.8,2.45a2.08,2.08,0,0,0,.86,0L21,24.27a.71.71,0,0,0,.47-.57L23.58.45a.4.4,0,0,0-.4-.45ZM19.17,5.34c0,.21-.06.59-.08.84L19,6.79c0,.24-.06.59-.07.78a2.63,2.63,0,0,1,0,.33H8.05a.4.4,0,0,0-.41.45l.19,2.14a.51.51,0,0,0,.49.44h10a.36.36,0,0,1,.36.4c0,.22-.05.6-.07.84l-.62,6.91c0,.25-.05.56-.06.7s-.22.3-.46.37l-5.2,1.44-.43.12-.44-.12L6.14,20.15a.71.71,0,0,1-.47-.57l-.33-3.76a.4.4,0,0,1,.4-.44H7.82a.5.5,0,0,1,.49.44l.13,1.47a.71.71,0,0,0,.47.57l2.44.65.43.12.44-.12,2.43-.66a.69.69,0,0,0,.48-.56l.26-2.95A.4.4,0,0,0,15,13.9H5.61a.5.5,0,0,1-.48-.45L4.48,6.18c0-.25-.06-.63-.08-.85a.38.38,0,0,1,.41-.39h14A.39.39,0,0,1,19.17,5.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.5abeef1ce4fb7208446c6bb47b18ee29.svg";
export { ForwardRef as ReactComponent };